import { api } from 'api';

/**
 * add
 * @param {*} data
 * @returns
 */
export const addCollection = (data) => {
  return api.call('collection.add', data);
};

/**
 * update
 * @param {*} data
 * @returns
 */
export const updateCollection = (data) => {
  return api.call('collection.update', data);
};

/**
 * del
 * @param {*} id 
 * @returns 
 */
export const deleteCollection = (id) => {
  return api.call('collection.delete', { id });
};
